// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3xAd5","itemTitle":"ClientEmergencyInfo_itemTitle__1j9tF","itemText":"ClientEmergencyInfo_itemText___dyBB"};